import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import VideoUpload from '../../../Components/Macro/ImgUpload/VideoUpload';
import { useAudios } from './AudioStore';
import { useAudioCat } from '../AudioCat/AudioCatState';

function Add() {
    const formRef = useRef();
    let { addVideo } = useAudios()
    let { cats, setCats } = useAudioCat()
    let [videoUrl, setVideoUrl] = useState('')
    
    useEffect(() => {
        setCats();
    }, [])
    
    const handleFinish = (values) => {
        let data = {
            ...values,
            url: videoUrl
        }
        addVideo(data);
        formRef.current?.resetFields();
        setVideoUrl('');
    }
    
    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
                autoComplete="off"
            >
                <Form.Item
                    label="Audio nomi"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: "To'ldirish majburiy",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Audioni yuklash"
                    name="url"
                >
                    <VideoUpload setVideo={setVideoUrl} />
                </Form.Item>
                <Form.Item
                    label="Kategoriyasi"
                    name="cat_id"
                >
                    <Select>
                        {cats.map((item) => (
                            <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Saqlash
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Add;